import kateAvatar from '../assets/images/kate.png';
import { isMouseWaitIntelligenceUser } from './mwIntelligence';

export function getMouseWaitUserAvatarUrl(user: any, fallbackUrl: string) {
  return isMouseWaitIntelligenceUser(user) ? kateAvatar : fallbackUrl;
}
